
const newModel = () => {
    return {
        donViId: null,
        maDonVi: null,
        ten: null,
        tenTat: null,
        sdt: null,
        donViChaId: null,
        quanHuyenId: null,
        tenQuanHuyen: null,
        tenCapDonVi: null,
        capDonViId: null,
        ghiChu: null,
        stt: null,
        dateCreated: null,
        dateModified: null,
        isDeleted: null,
        dateDeleted: null,
        userCreated: null,
        userModified: null,
        userDeleted: null,
        enabled: null,
        enabledDisplay: null,
    }
}

const newFEModel = () => {
    return {
        donViId: null,
        maDonVi: null,
        ten: null,
        tenTat: null,
        sdt: null,
        donViChaId: null,
        quanHuyenId: null,
        tenQuanHuyen: null,
        tenCapDonVi: null,
        capDonViId: null,
        ghiChu: null,
        stt: null,
        enabled: null,
        enabledDisplay: null,
    }
}

const fromJson = (item) => {
    return {

    }
}

const parseModeltoFEModel = (item) => {
    return {

    }
}

const errors = () => {
    return {

    }
}

export const donViModel = {
    newModel,
    newFEModel,
    parseModeltoFEModel,
    fromJson,
    errors,
}


